import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Patterns } from '../utils/constants';

@Directive({
	selector: '[appAutoFocus]',
})
export class AutoFocusDirective {
	@Input('appAutoFocusIndex') index!: number;
	@Input('appAutoFocusMax') max!: number;

	constructor(
		private readonly el: ElementRef<HTMLInputElement>,
		private readonly control: NgControl
	) {}

	@HostListener('input', ['$event'])
	onInput(event: Event) {
		const input = event.target as HTMLInputElement;
		const value = input.value;

		if (!Patterns.oneDigit.test(value)) {
			this.control.control?.setValue('');
			return;
		}

		if (value && this.index < this.max - 1) {
			const next = this.el.nativeElement.parentElement?.querySelectorAll('input')[
				this.index + 1
			] as HTMLInputElement;
			next?.focus();
		}
	}

	@HostListener('keydown', ['$event'])
	onBackspace(event: KeyboardEvent) {
		if (event.key !== 'Backspace') {
			return;
		}
		const input = event.target as HTMLInputElement;

		if (!input.value && this.index > 0) {
			const prev = this.el.nativeElement.parentElement?.querySelectorAll('input')[
				this.index - 1
			] as HTMLInputElement;
			prev?.focus();
		}
	}
}
